import useUploadImage from "@babackapp/private-api-client/client/use-upload-image";
import { useCurrentShopSuspense } from "./shops/use-current-shop-suspense";

export default function useUploadPortalBackgroundImage() {
	const { data: shop } = useCurrentShopSuspense();
	return useUploadImage(
		shop.id,
		"/shops/{shopId}/preferences/portals/background",
	);
}
